const MAX_FILE_COUNT = 5;
const MAX_FILE_SIZE_BYTES = 50 * 1024 * 1024;

const SUPPORTED_EXTENSIONS = new Set([
  'pdf',
  'doc',
  'docx',
  'ppt',
  'pptx',
  'xls',
  'xlsx',
  'csv',
]);

export interface CIMTeaserFileValidation {
  valid: boolean;
  error?: string;
}

function extensionFor(file: File): string {
  return file.name.split('.').pop()?.toLowerCase() || '';
}

export function validateCIMTeaserFiles(files: File[]): CIMTeaserFileValidation {
  if (files.length === 0) {
    return { valid: false, error: 'Upload at least one CIM or supporting document.' };
  }

  if (files.length > MAX_FILE_COUNT) {
    return { valid: false, error: 'Upload up to 5 documents for CIM Analysis.' };
  }

  const oversized = files.find((file) => file.size > MAX_FILE_SIZE_BYTES);
  if (oversized) {
    return { valid: false, error: `${oversized.name} exceeds the 50MB file limit.` };
  }

  const unsupported = files.find((file) => !SUPPORTED_EXTENSIONS.has(extensionFor(file)));
  if (unsupported) {
    return { valid: false, error: `${unsupported.name} is not supported for CIM Analysis.` };
  }

  return { valid: true };
}
